import IIncome from "@/module/main/dto/customer/IIncome";
import IAmount from "@/module/main/dto/IAmount";
import Amount from "@/module/main/dto/Amount";
import IncomeType from "@/module/main/dto/customer/IncomeTypeEnum";
import IncomeTypeEnum from "@/module/main/dto/customer/IncomeTypeEnum";
import IEmployee from "@/module/main/dto/customer/IEmployee";
import IEntrepreneur from "@/module/main/dto/customer/IEntrepreneur";

export default class Income implements IIncome {
    constructor(
        public type?: IncomeType,
        public amount?: IAmount,
        public employee?: IEmployee,
        public entrepreneur?: IEntrepreneur
    ) {}
}
